// libs
import React from 'react';
import PropTypes from 'prop-types';

// components
import { ConditionalComponent } from 'components';

// styles
import './tableHead.scss';

/**
 * Represents the header component for a page table.
 */
const TableHead = props => {
    const { tableHeading, rightComponent, customTableHeadClass } = props;
    return (
        <div className={`page-header-wrapper ${customTableHeadClass}`}>
            <div className="page-header-left">
                <ConditionalComponent isVisible={tableHeading}>
                    <h3 className="table-heading">{tableHeading}</h3>
                </ConditionalComponent>
            </div>
            {/* TODO! Add export functionality and extra buttons */}
            <div className="page-header-right">
                <ConditionalComponent isVisible={rightComponent}>
                    {rightComponent}
                </ConditionalComponent>
            </div>
        </div>
    );
};

// PropType validation for TableHead component
TableHead.propTypes = {
    tableHeading: PropTypes.string,
    rightComponent: PropTypes.node,
    customTableHeadClass: PropTypes.string,
};

export default TableHead;
